let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("hyPLc")).then(() => parcelRequire('l9Clz'));